import React, {Component} from 'react';
import Slider from "react-slick";
import Book from './Book';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';
import "./SliderComp.css";


export default class SimpleSlider extends Component {


    getSlidesToShow() {
        let wdt = $(document).width();
        console.log(wdt);
        if (wdt < 445) {
            return 1;
        } else if (wdt < 665) {
            return 2;
        }
        else if (wdt < 885) {
            return 3;
        }
        else if (wdt < 1105) {
            return 4;
        }

        else if (wdt < 1445) {
            return 5;
        }
        else {
            return 6;
        }
    }


    render() {

        if (this.props.data.length === 0) {
            return (
                <div>

                </div>
            )
        }


        let slidesnumber = this.getSlidesToShow();
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: slidesnumber,
            slidesToScroll: 1,
            autoplay: this.props.autoplay,
        };
        return (
            <div>
                <h2 className={"buyukbaslik"}> {this.props.header}</h2>
                <Slider {...settings}>
                    {this.props.data.map((book, index) => (
                        <Book typee={1} key={book.id} {...book} />
                    ))}
                </Slider>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/SilderComp.js